module.exports = __webpack_public_path__ + "img/product_127.2268994.webp";